import Mixin from "../mixin.js";
import Renderer from "./utils/Renderer.js";
import Funnel from "../services/funnel-service.js";
import Utils from "../services/utils-service.js";
import tooltip from "./utils/tooltip.js"
var iconic = IconicJS();
//we need to break down sections into its own compponent eventually -G
const template = `
<div>
    <section 
    v-for="(page_uid, page_index) in funnel.idsMap.pages_sequence" 
    :key="'page-' + page_index" 
    :id="page_uid" 
    class="grid " 
    v-if="routing(page_uid) && !loading.status" 
    role="section" 
    :ref="page_uid" 
    
    >
        <div id="page-announcer" aria-live="polite" role="status" class="sr-only"></div>
       

        <form  :id="'form-' + page_uid" novalidate  :class="funnel.elements[page_uid].page_class" :keypress="onKeyPress">

            <component 
            :is="funnel.elements[page_uid].title_tag ? funnel.elements[page_uid].title_tag : 'h1'" 
            v-if="hasPageTitle(funnel.elements[page_uid])"
            class="page-title text-center" 
            :class="funnel.elements[page_uid].title_class"
            :id="funnel.elements[page_uid].uid+'_title'"
            >
                
                <img :alt="funnel.elements[page_uid].icon_alt || 'Page icon'" v-if="funnel.elements[page_uid].icon_name" :src="icon(funnel.elements[page_uid].icon_name)" width="100" height="100" class="icon center">
                <span v-html="fs.parseHtml(computedPageTitle(funnel.elements[page_uid]))"></span>
                <b-tooltip :element='funnel.elements[page_uid]' v-if="funnel.elements[page_uid].helpText"/>
            </component>

            <component :is="funnel.elements[page_uid].description_tag ? funnel.elements[page_uid].description_tag : 'h2'" v-if="funnel.elements[page_uid].description"  :class="'page-description text-center '+ funnel.elements[page_uid].description_class " v-html="fs.parseHtml(funnel.elements[page_uid].description)">
            
            </component>


            <div 
            :class="secClass(page_uid) + ' sections_container grid'" >
                
                <section 
                v-for="(section_uid, section_index) in funnel.idsMap.pages[page_uid].sections_sequence" 
                :id="section_uid" 
                :key="'section-' + section_index" 
                v-if="fs.display(funnel.elements[section_uid])"  
                :class="sectionCssClass(section_uid)"
                >


                    <component 
                    :is="funnel.elements[section_uid].title_tag ? funnel.elements[section_uid].title_tag : 'h1'" 
                    v-if="hasSectionTitle(funnel.elements[section_uid])"
                    class="section-title text-center" 
                    :class="computedTitleClass(funnel.elements[section_uid], section_index)"
                    :id="'section_title_'+section_uid"
                    >
                    
                        <span v-html="computedTitle(funnel.elements[section_uid])"></span>
                        <b-tooltip :element='funnel.elements[section_uid]' v-if="funnel.elements[section_uid].helpText"/>
                        <img :alt="funnel.elements[section_uid].title_icon_alt || 'Section icon'" v-if="funnel.elements[section_uid].title_icon" @click="eventHandler($event, section_uid)" :src="funnel.elements[section_uid].title_icon" width="20" height="20">
                    </component>
                    
                    <component 
                    :is="funnel.elements[section_uid].description_tag ? funnel.elements[section_uid].description_tag : 'h2' " 
                    v-if="funnel.elements[section_uid].description" 
                    :class="'section-description '+ funnel.elements[section_uid].description_class" 
                    v-html="fs.parseHtml(funnel.elements[section_uid].description)"
                    :id="'section_description_'+section_uid"
                    >
                    </component>


                    <div class="grid renderer-container">
                        <renderer v-for="(input_uid, index) in funnel.idsMap.pages[page_uid].sections[section_uid].inputs_sequence" :ref="input_uid" :id="'container_'+input_uid" :key="input_uid+'-key-' + index" :class="inputCssClass(input_uid)" v-if="fs.display(funnel.elements[input_uid])" :iuid="input_uid" />
                    </div>
                </section>

                <nav class="s12 clm " role="navigation" v-if="isCard(funnel.elements[page_uid])">
                   <div class="grid">
                        <div class="s12 m3 l4 clm" v-if="isCard(funnel.elements[page_uid]) && fs.isShowPreviousButton(page_uid)">
                            <a class="prev"
                                v-if="fs.isShowPreviousButton(page_uid)"
                                @click.prevent="fs.previous(page_uid)"
                                @keydown.space.prevent="fs.previous(page_uid)"
                                @keydown.enter.prevent="fs.previous(page_uid)"
                                :data-uid="page_uid+'_card_back_btn'"
                                tabindex='0'
                                role="button"
                                aria-label="Go to the previous step"
                            >
                                {{prevBtnText(page_uid)}}
                            </a>

                        </div>

                        <div class="center s12 m6 l4 clm center" v-if="isCard(funnel.elements[page_uid])">
                            <button v-if="fs.isShowNextButton(page_uid, reload(page_uid))"
                                class="button medium action fill primary-btn next-step"
                                @click.prevent="fs.next(page_uid, reload(page_uid))"
                                :data-uid="page_uid+'_card_next_btn'"
                                :aria-label="'Go to the next step: '+ nextBtnText(page_uid)"
                            >
                                {{nextBtnText(page_uid)}}
                                <img class="card-icon iconic iconic-sm" data-direction="right" data-head="line-large-oblique" data-src="/static/images/iconic/arrow.svg">
                            </button>
                            <button v-if="isShowSubmitButton()"
                                class="button large action primary-btn fill submit-app"
                                @click.prevent="next(page_uid)"
                                :data-uid="page_uid+'_card_sbmt_btn'"
                                aria-label="Go to the next step, Submit your application"
                            >
                                Submit Your Application
                                <img class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/thumb.svg">
                            </button>
                        </div>
                    </div>
                </nav>
                

            </div>
        </form>
        <nav :class="funnel.elements[page_uid].page_class" v-if="!isCard(funnel.elements[page_uid])" role="navigation" >
            <div class="grid">
                <div class="s2 m3 l3 clm" v-if="fs.isShowPreviousButton(page_uid)">
                    <a 
                        class="prev"
                        @click.prevent="fs.previous(page_uid)"
                        @keydown.space.prevent="fs.previous(page_uid)"
                        @keydown.enter.prevent="fs.previous(page_uid)"
                        :data-uid="page_uid+'_back_btn'"
                        tabindex='0'
                        role="button"
                        aria-label="Go to the previous step"
                    >
                     {{prevBtnText(page_uid)}}
                    </a>
                </div>
                <div class="s8 m6 l6 clm" :style="window.width < 600 ? 'min-width: 80%;' : ''" :class="!fs.isShowPreviousButton(page_uid) ? 'center' : ''"   v-if="fs.isShowNextButton(page_uid, reload(page_uid)) || isShowSubmitButton()">
               
                    <component 
                    :is="bei_item.element" 
                    v-for="(bei_item,bei_index) in computedBEI"  
                    :id="'before_end_item_'+bei_item.element+'_'+bei_index"
                    v-bind="bei_item.attr" 
                    :key="'before_end_item_'+bei_item.element+'_'+bei_index"
                    >
                        <span v-if="bei_item.label" v-html="fs.parseHtml(bei_item.label)"></span>
                    </component>

                    <button v-if="fs.isShowNextButton(page_uid, reload(page_uid))" 
                        class="button medium action fill primary-btn next-step"
                        :class="nextDisabled "
                        :disabled="nextDisabled.indexOf('disabled') >= 0"
                        @click.prevent="fs.next(page_uid, reload(page_uid))"
                        :data-uid="page_uid+'_next_btn'"
                        :aria-label="'Go to the next step: '+nextBtnText(page_uid)"
                    >
                        {{nextBtnText(page_uid)}}
                        
                        <img class="card-icon iconic iconic-sm" data-direction="right" data-head="line-large-oblique" :data-src="funnel.elements[page_uid].button_next_link ? '/static/images/iconic/external-link.svg' :'/static/images/iconic/arrow.svg'">

                    </button>
                    <button v-if="isShowSubmitButton()"
                        class="button large action primary-btn fill submit-app"
                        @click.prevent="next(page_uid)"
                        :data-uid="page_uid+'_sbmt_btn'"
                        aria-label="Go to the next step, Submit your application"
                    >
                        Submit Your Application
                        <img class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/thumb.svg">
                    </button>
                </div>
            </div>

        </nav>

    </section>

</div>
`;

export default {
    name: 'page-component',
    template,
    mixins: [Mixin],
    components: {
        'renderer': Renderer,
        'b-tooltip': tooltip
    },
    data() {
        return {
            eventHandlers: new Map()
        }
    },
    mounted() {
        console.log('page.js mounted');
        this.fs.destroyAdHocSeq(this.$route.path);
        var self = this;
        this.$nextTick(function () {
            console.log(self);
            self.fs.registerModalHook(self, 'initModal');
            iconic.inject('.icon, .iconic');
            
        });  
    },
    watch: {
        "active_page"(newVal) {
            if (newVal != "" && newVal !== undefined) {
                this.fs.setDynamicTextVars()
                this.trackGTM()
                this.fs.setMetadata()
            }
        },
        "loading.status"(newVal){
            var self = this;
            if (newVal == false) {
                this.$nextTick(function(){
                    self.computedMainAriaLabel()
                    Funnel.ADAbuttons()
                })
                
            }
        }
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel',
            'current_lob',
            'window',
            'loading'
        ]),
        active_page: function () {
            return this.$store.getters.active_page
        },
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        nextDisabled: function () {
            const status = [];
            let is_disabled = false;

            if (this.$store.getters.disable_next) {
                is_disabled = true;
            }

            if (!is_disabled) {
                Object.keys(this.funnel.elements).map((el, i) => {
                    if (!this.funnel.elements[el]) {
                        return;
                    }

                    if (this.funnel.elements[el].loading) {
                        is_disabled = true;
                    }
                });
            }

            if (is_disabled) {
                status.push('disabled');
            }

            return status;
        },
        computedBEI: function () {
            var BEI_keys = Object.keys(this.funnel.elements.sc_talk_it_out.before_next_btn_items).map((el, i) => {
                if(this.funnel.elements.sc_talk_it_out.before_next_btn_items[el]){
                    return el
                }
            });
            
            BEI_keys = BEI_keys.filter(element => element !== undefined);

            console.log("keys ", BEI_keys, this.current_lob);

            var BEI_elements = [];
            
            if (BEI_keys.includes('global')) {
                BEI_elements.push(this.funnel.elements.sc_talk_it_out.before_next_btn_items.global)
            }
            if (BEI_keys.includes(this.current_lob)) {
                BEI_elements.push(this.funnel.elements.sc_talk_it_out.before_next_btn_items[this.current_lob])
            } 
            console.log(BEI_elements);
            return BEI_elements
           
        }
    },
    updated: function () {
        this.fs.transitionEnter()
    },
    methods: {
        secClass: function (page_uid) {
            if (this.funnel.elements[page_uid].sections_class) {
                return this.funnel.elements[page_uid].sections_class;
            } else {
                return '';
            }
        },
        isCard: function (page) {
            if (!page.sections_class) {
                return;
            }
            return page.sections_class.indexOf('card') >= 0;
        },
        hasPageTitle: function (page) {
            return (!Utils.isEmpty(page.page_title) || !Utils.isEmpty(page.page_titles));
        },
        computedPageTitle: function (page) {
            var titleText = page.page_title;
            if (!Utils.isObjEmpty(page.page_titles)) {
                for (const title of page.page_titles) {
                    if (this.fs.display(title)) {
                        titleText = title.text;
                    }
                }
            }
            return titleText;
        },
        computedTitleClass: function (input, index) {
            var titleClass = ['section-' + index]
            if (input.title_class) {
                titleClass.push(input.title_class)
            }
            if (input.helpText) {
                titleClass.push(' tooltip ')
            }
            return titleClass
        },
        hasSectionTitle: function (section) {
            return (!Utils.isEmpty(section.title) || !Utils.isEmpty(section.titles));
        },
        computedTitle: function (section) {
            var titleText = section.title;
            if (!Utils.isObjEmpty(section.titles)) {
                for (const title of section.titles) {
                    if (this.fs.display(title)) {
                        titleText = title.text;
                    }
                }
            }
            return titleText;
        },
        routing(puid) {
            var isActive = false;
            var page = this.funnel.elements[puid];

            if (!Utils.isObjEmpty(page) && page.page_route == this.$route.path) {
                // this.$store.dispatch('calculateCompletePercent');
                var self = this
                isActive = true;
                // Set active page for pulling form name for a page.
                this.$store.commit('UPDATE', { prop: 'active_page', val: page.uid });
            }
            return isActive;
        },
        reload(puid) {
            return this.funnel.elements[puid].page_reload;
        },
        eventHandler(e, uid) {
            const element = this.$store.getters.funnel.elements[uid];
            const lib = { ctx: this.$store, router: this.$router };
            const srv = eval(`new ${element.vueService}(lib)`);
            eval(`srv.${element.fxn}(e, element)`);
        },
        /* isTruthy(val) { John M: deprecated, see mixin.
            return Utils.isTruthy(val);
        }, */
        inputCssClass(iuid) {
            // console.log('Element: ${iuid} is:', this.funnel.elements[iuid]);

            var cssClass = ``;


            if (iuid != null || this.funnel.elements[iuid].class.indexOf('clm') == -1) {
                cssClass = `clm ${this.funnel.elements[iuid].class} `;
            } else {
                cssClass = `${this.funnel.elements[iuid].class} `;
            }

            const element = this.$store.getters.funnel.elements[iuid];

            if (element.class_display) {
                const cdRet = this.fs.class_display(element)

                if (cdRet) {
                    if (cdRet.append) {
                        cssClass += cdRet.return
                    }
                    else {
                        cssClass = cdRet.return
                    }
                }
            }

            return cssClass;
        },
        // sectionDescription: function (str) {
        //     return str
        //         // .replace(/[\\]/g, "\\\\")
        //         // .replace(/[\"]/g, '\\"')
        //         // .replace(/[\/]/g, "\\/")
        //         // .replace(/[\b]/g, "\\b")
        //         // .replace(/[\f]/g, "\\f")
        //         .replace(/[\n]/g, "<br>");
        //     // .replace(/[\r]/g, "\\r")
        //     // .replace(/[\t]/g, "\\t");

        // },
        sectionCssClass: function (section_uid) {
            // return this.funnel.elements[section_uid].sc_class ? this.funnel.elements[section_uid].sc_class : 's12 clm'
            var cssClass = 's12 clm '

            if (this.funnel.elements[section_uid].sc_class) {
                cssClass = `clm ${this.funnel.elements[section_uid].sc_class}`;
            }
            const element = this.$store.getters.funnel.elements[section_uid];

            if (element.class_display) {
                const cdRet = this.fs.class_display(element)

                if (cdRet) {
                    if (cdRet.append) {
                        cssClass += cdRet.return
                    }
                    else {
                        cssClass = cdRet.return
                    }
                }
            }
            // console.log(section_uid, cssClass);
            return cssClass;
        },
        isShowSubmitButton: function () { },
        incrementOrRedirect: function () {
            console.log('incrementOrRedirect');
            // if (this.isShowSubmitButton()) {
            //     location.assign('3');
            // } else {
            this.incrementFormStep();
            // }
        },
        nextBtnText: function (page_uid) {
            const puid = this.fs.getNextPUID(page_uid, this.reload(page_uid));

            return this.fs.computeNextButtonText(puid, false, page_uid);
        },
        prevBtnText: function (page_uid) {
            // if (!this.funnel.elements[this.fs.getPrevPUID(page_uid)].button_text) {
            return "Back"
            // }
            // return this.funnel.elements[this.fs.getPrevPUID(page_uid)].button_text
        },
        icon: function (text) {
            const pathToIcon = '/static/images/card-icons/'
            const iconFormat = '.svg'
            const iconName = text.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "");

            return pathToIcon + iconName + iconFormat;
        },
        onKeyPress(e) {
            let key = e.charCode || e.keyCode || 0;
            if (key == 13) { // prevent enter from submitting page
                e.preventDefault();
            }
        },
        trackGTM() {
            if (this.$gtm !== undefined) {
                this.$gtm.trackView(this.funnel.elements[this.active_page].meta_description, this.$route.path);
            }
        },
        computedMainAriaLabel: function(){
            var self = this;
            
            let main = $('main')
            let first_title = $('main').find("[class*='-title']")
            let first_description = $('main').find("[class*='-description']")
            let main_aria_label = first_title.text()+" "+first_description.text()
            main.attr('aria-label', main_aria_label);
        }
        
    },
    beforeUnmount() {
        this.fs.unregisterModalHook(this);
    },
};
